import type { InputPort, OutputPort } from 'common/api/v1/types'
import {
    CoaxPortMode,
    ComprimatoPortMode,
    IpPortMode,
    MatroxPortMode,
    SrtMode,
    VideonPortMode,
    ZixiMode,
} from 'common/api/v1/types'

export function inputTypeFromPort(port: InputPort) {
    switch (port.mode) {
        case CoaxPortMode.sdi: // fallthrough
        case MatroxPortMode.matroxSdi:
        case ComprimatoPortMode.comprimatoSdi:
            return 'SDI'
        case CoaxPortMode.asi:
            return 'ASI'
        case ComprimatoPortMode.comprimatoNdi:
            return 'NDI'
        case VideonPortMode.videonAuto:
            return 'Videon auto'
        case VideonPortMode.videonSdi:
            return 'Videon SDI'
        case VideonPortMode.videonHdmi:
            return 'Videon HDMI'
        case IpPortMode.rist:
            return 'RIST'
        case IpPortMode.rtmp:
            return 'RTMP'
        case IpPortMode.rtp:
            return 'RTP'
        case IpPortMode.udp:
            return 'UDP'
        case IpPortMode.generator:
            return 'Generator'
        case IpPortMode.zixi:
            switch (port.zixiMode) {
                case ZixiMode.pull:
                    return 'Zixi pull'
                case ZixiMode.push:
                    return 'Zixi push'
                default:
                    return 'Zixi'
            }
        case IpPortMode.srt:
            switch (port.srtMode) {
                case SrtMode.listener:
                    return 'SRT listener'
                case SrtMode.caller:
                    return 'SRT caller'
                case SrtMode.rendezvous:
                    return 'SRT rendezvous'
                default:
                    return 'SRT'
            }
        default:
            return 'N/A'
    }
}

export function outputType(port?: OutputPort) {
    if (!port) {
        return 'Not configured'
    }
    switch (port.mode) {
        case CoaxPortMode.sdi: // fallthrough
        case ComprimatoPortMode.comprimatoSdi:
        case MatroxPortMode.matroxSdi:
            return 'SDI'
        case CoaxPortMode.asi:
            return 'ASI'
        case IpPortMode.rist:
            return 'RIST'
        case IpPortMode.rtmp:
            return 'RTMP'
        case IpPortMode.rtp:
            return 'RTP'
        case IpPortMode.udp:
            return 'UDP'
        case IpPortMode.zixi:
            switch (port.zixiMode) {
                case ZixiMode.pull:
                    return 'Zixi pull'
                case ZixiMode.push:
                    return 'Zixi push'
                default:
                    return 'Zixi'
            }
        case IpPortMode.srt:
            switch (port.srtMode) {
                case SrtMode.listener:
                    return 'SRT listener'
                case SrtMode.caller:
                    return 'SRT caller'
                case SrtMode.rendezvous:
                    return 'SRT rendezvous'
                default:
                    return 'SRT'
            }
        case ComprimatoPortMode.comprimatoNdi:
            return 'NDI'
        default:
            return 'N/A'
    }
}

export function formatTransformationType(type: string): string {
    switch (type) {
        case 'transcode':
            return 'Transcode'
        case 'mpts-demux':
            return 'MPTS Demux'
        case 'audio-reshuffling':
            return 'Audio Reshuffling'
        case 'ad-insertion':
            return 'Ad Insertion'
        case 'pid-remapping':
            return 'PID Remapping'
        case 'framerate-conversion':
            return 'Frame-rate Conversion'
        default: {
            const spaced = type.replace(/-/g, ' ')
            return spaced.charAt(0).toUpperCase() + spaced.slice(1)
        }
    }
}
